import { DigitalCoachWidget } from '../../../../widgets/digital-coach-widget';
import { withStoryBlockWrapper } from '../hocs/with-story-block-wrapper';

export const DigitalCoach = withStoryBlockWrapper(DigitalCoachWidget);
